import React from 'react'

import { useSurveyQueryReferencedCustomerAttributeIds } from '~/hooks/useSurveyQuery'

import { useCustomerAttributeGroup } from './useCustomerAttributeGroup'

export const useCustomerAttributeItems = () => {
  const referencedIds = useSurveyQueryReferencedCustomerAttributeIds()
  const customerAttributeGroup = useCustomerAttributeGroup()
  const customerAttributes = React.useMemo(
    () => customerAttributeGroup?.customerAttributes ?? [],
    [customerAttributeGroup?.customerAttributes],
  )

  const items = React.useMemo(
    () =>
      customerAttributes.map((customerAttribute, index) => ({
        id: customerAttribute.id,
        name: customerAttribute.name,
        index,
        isDisabled: referencedIds.includes(customerAttribute.id),
      })) ?? [],
    [referencedIds, customerAttributes],
  )

  const enabledIndices = React.useMemo(
    () => items.filter((item) => !item.isDisabled).map((item) => item.index),
    [items],
  )

  return {
    customerAttributes,
    items,
    enabledIndices,
    groupName: customerAttributeGroup?.name,
  }
}
